import React, { useEffect, useState, useMemo } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { authHeader } from "../../../../../../helpers";
import { apiConstants } from "../../../../../../constants/api/api.constants";
import { useStyles } from "../../../../../../Theme/Style";
import styles from "./../ParameterForm.module.scss";

const LabelView = (props) => {
  const classes = useStyles();
  const { title, titleSingle, paramdata } = props;

  const [loading, setLoading] = useState(true);
  const [label, setLabel] = useState(null);
  const [labelTypes, setLabelTypes] = useState([]);

  const labelId = paramdata?.id; // props only has { id: ... }

  // ----- Load label types -----
  useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: authHeader(),
    };

    fetch(`${apiConstants.API_URL}/label-types`, requestOptions)
      .then((response) => response.text())
      .then((text) => {
        const data = text && JSON.parse(text);
        setLabelTypes(data?.data || []);
      })
      .catch(() => {
        setLabelTypes([]);
      });
  }, []);

  // ----- Load label by ID -----
  useEffect(() => {
    if (!labelId) return;

    const requestOptions = {
      method: "GET",
      headers: authHeader(),
    };

    // adjust URL to match your backend route
    fetch(`${apiConstants.API_URL}/labels/${labelId}`, requestOptions)
      .then((response) => response.text())
      .then((text) => {
        const data = text && JSON.parse(text);
        // assuming API returns { data: { id, name, image, image_url, label_type_id } }
        setLabel(data?.data || null);
      })
      .finally(() => setLoading(false));
  }, [labelId]);

  // ----- Resolve label type name -----
  const labelTypeName = useMemo(() => {
    if (!label || !labelTypes.length) return "-";
    const lt = labelTypes.find((t) => t.id === label.label_type_id);
    return lt?.name || "-";
  }, [label, labelTypes]);

  if (!labelId) {
    return (
      <Typography variant="body1" color="error">
        Label ID not provided.
      </Typography>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!label) {
    return (
      <Typography variant="body1" color="error">
        Label not found.
      </Typography>
    );
  }

  return (
    <div>
      {/* Back button */}
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Link to="../" style={{ display: "block" }}>
          <Button
            size="medium"
            startIcon={<ArrowBackIcon size="small" />}
            sx={{ textTransform: "none" }}
          >
            Back to {title}
          </Button>
        </Link>
      </Grid>

      <Card elevation={0} sx={{ p: 2 }}>
        <CardContent>
          {/* Label Type */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                gutterBottom
              >
                Label Type
              </Typography>
              <Typography variant="body1">{labelTypeName}</Typography>
            </Grid>

            {/* Label Name */}
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                gutterBottom
              >
                Label Name
              </Typography>
              <Typography variant="body1">{label.name}</Typography>
            </Grid>
          </Grid>

          {/* Image */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                gutterBottom
              >
                Label Image
              </Typography>

              <Card
                elevation={0}
                sx={{
                  border: "1px dashed #bbb",
                  maxWidth: 300,
                }}
              >
                <Box sx={{ p: 1 }}>
                  {label.image_url ? (
                    <img
                      alt={label.name}
                      src={label.image_url}
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "11.5rem",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Box sx={{ p: 5, textAlign: "center" }}>
                      <Typography variant="body2" color="text.secondary">
                        No image available
                      </Typography>
                    </Box>
                  )}
                </Box>
                {/* <CardContent sx={{ px: 0, py: 0, pb: "1rem !important" }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center", fontSize: "0.75rem", m: 0 }}
                  >
                    {label.image || "No image path"}
                  </Typography>
                </CardContent> */}
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default LabelView;
